import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { CloseOutlined } from '@ant-design/icons';

import * as Colors from '../../attrs/colors';
import * as Shadows from '../../attrs/shadows';
import MQ from '../../attrs/mq';

export const Container = styled.div`
  overflow-x: scroll;
  margin-left: -1rem;
  margin-right: -1rem;

  ${MQ.md`
    overflow-x: visible;
  `}
`;

export const PlanContainer = styled.div`
  display: flex;

  :after,
  :before {
    content: '';
    border: 0.25rem solid transparent;
  }

  ${MQ.md`
    :after,
    :before {
      display: none;
    }
  `}
`;

const PlanIsElevated = theme('isElevated', {
  true: css`
    ${MQ.md`
      flex: 1.2;
      margin-top: 0;
      box-shadow: ${Shadows.SHADOW_30}, ${Shadows.SHADOW_40};
    `}
  `,
});

export const Plan = styled.div`
  border: 1px solid ${Colors.GREY_70};
  flex: 1;
  margin-bottom: 1rem;
  min-width: 280px;
  margin: 1rem 0.5rem 0;

  ${MQ.sm`
    min-width: 300px;
  `}

  ${MQ.md`
    min-width: auto;
  `}

  ${PlanIsElevated};
`;

export const PlanHeader = styled.div`
  text-align: center;
  padding: 1rem;

  ${MQ.lg`
    padding: 1.5rem;
  `}
`;

export const PlanTitle = styled.h3`
  font-weight: bold;
  font-size: 1.6rem;
  margin-bottom: 1rem;

  ${MQ.lg`
    font-size: 1.8rem;
  `}
`;

export const PlanDesc = styled.div`
  font-size: 1.1rem;
  margin-bottom: 1rem;
`;

export const PlanBody = styled.div``;

export const Price = styled.div`
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: -1px;
  color: ${Colors.BLACK};

  ${MQ.lg`
    font-size: 2.8rem;
    letter-spacing: -2px;
  `}
`;

export const PriceNote = styled.div`
  color: ${Colors.GREY_60};
  margin-bottom: 1rem;
`;

export const ListTitle = styled.h4`
  font-weight: bold;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  border-top: 1px solid ${Colors.GREY_70};
  border-bottom: 1px solid ${Colors.GREY_70};
  background: ${Colors.GREY_90};

  ${MQ.lg`
    padding: 0.5rem 1.5rem;
  `}
`;

export const List = styled.ul`
  margin: 0.5rem 0;
  padding: 0 1rem;
  list-style: none;

  ${MQ.lg`
    padding: 0 1.5rem;
  `}
`;

export const ListItem = styled.li`
  display: flex;
  margin: 0.5rem 0;

  ${MQ.md`
    flex-direction: column;
  `}

  ${MQ.lg`
    flex-direction: row;
    margin: 1rem 0;
  `}
`;

export const ListItemLabel = styled.span`
  display: flex;
  align-items: center;
  flex: 1;

  > span {
    margin-right: 0.5rem;
  }

  ${MQ.md`
    font-weight: bold;
  `}

  ${MQ.lg`
    font-weight: normal;
  `}
`;

export const ListItemValue = styled.span``;

export const Link = styled.a`
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
`;

export const UnavailableIcon = styled(CloseOutlined)`
  opacity: 0.4;
`
